var hasProp = window.hasProp;
var extend = window.extend;
var extend = function (child, parent) {
    for (var key in parent) {
      if (hasProp.call(parent, key)) child[key] = parent[key];
    }
    function ctor() {
      this.constructor = child;
    }
    ctor.prototype = parent.prototype;
    child.prototype = new ctor();
    child.__super__ = parent.prototype;
    return child;
  },
  hasProp = {}.hasOwnProperty;
window.Aedu.Auth.SignupWallController = function (superClass) {
  extend(SignupWallController, superClass);
  function SignupWallController() {
    return SignupWallController.__super__.constructor.apply(this, arguments);
  }
  SignupWallController.prototype.events = {
    'click .js-signup-login-button': 'handleLogin',
    'click .js-signup-open-email-form': 'showEmailForm'
  };
  SignupWallController.prototype.initialize = function () {
    this.notifier = new c.Server.Notification('sutd');
    return this.initResize();
  };
  SignupWallController.prototype.handleLogin = function (e) {
    e.preventDefault();
    return window.parent.location.href = $a.loginUrlWithRedirect(document.referrer);
  };
  SignupWallController.prototype.initResize = function () {
    return $(document).bind("set_iframe_size", function (_this) {
      return function () {
        return _this.triggerResize();
      };
    }(this));
  };
  SignupWallController.prototype.triggerResize = function () {
    return $(document).trigger("resize_boxy", this.newHeight());
  };
  SignupWallController.prototype.newHeight = function () {
    return this.$el.parent('body').height();
  };
  SignupWallController.prototype.showEmailForm = function () {
    $('.js-signup-email-form-container').removeClass('u-displayNone');
    $('.js-signup-connect-buttons').addClass('u-displayNone');
    return this.triggerResize();
  };
  return SignupWallController;
}(Backbone.View);
window.extend = extend;
window.hasProp = hasProp;